module.exports = __webpack_public_path__ + "img/CFBG11.3e7ec18b.png";